import request from '@/utils/request'
import { btcguid } from '@/utils/validate'

export default {
  getFrontExportToChinatOrigin: function(params) {
    return request({
      url: '/GetFrontExportToChinatOrigin',
      method: 'post',
      data: {
        MessageType: 4001,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn
        }
      }
    })
  },
  getFrontExportToChinatData: function(params) {
    return request({
      url: '/GetFrontExportToChinatData',
      method: 'post',
      data: {
        MessageType: 4002,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin,
          MeatType: params.MeatType,
          FeedingMode: params.FeedingMode,
          StorageMode: params.StorageMode,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  getFrontCountrySlaughterOrigin: function(params) {
    return request({
      url: '/GetFrontCountrySlaughterOrigin',
      method: 'post',
      data: {
        MessageType: 4003,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn
        }
      }
    })
  },
  getFrontCountrySlaughterData: function(params) {
    return request({
      url: '/GetFrontCountrySlaughterData',
      method: 'post',
      data: {
        MessageType: 4004,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  getFrontPlantSlaughterOrigin: function(params) {
    return request({
      url: '/GetFrontPlantSlaughterOrigin',
      method: 'post',
      data: {
        MessageType: 4005,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn
        }
      }
    })
  },
  getFrontPlantSlaughterPlantNo: function(params) {
    return request({
      url: '/GetFrontPlantSlaughterPlantNo',
      method: 'post',
      data: {
        MessageType: 4006,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin
        }
      }
    })
  },
  getFrontPlantSlaughterData: function(params) {
    return request({
      url: '/GetFrontPlantSlaughterData',
      method: 'post',
      data: {
        MessageType: 4007,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin,
          PlantNo: params.PlantNo,
          DateType: params.DateType,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  getFrontGreyChannelData: function(params) {
    return request({
      url: '/GetFrontGreyChannelData',
      method: 'post',
      data: {
        MessageType: 4008,
        MessageID: btcguid(),
        Data: {
          MeatType: params.MeatType,
          OriginType: params.OriginType,
          Country: params.Country,
          CountryEn: params.CountryEn,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  getFrontCustomOrigin: function(params) {
    return request({
      url: '/GetFrontCustomOrigin',
      method: 'post',
      data: {
        MessageType: 4009,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn,
          Custom: params.Custom
        }
      }
    })
  },
  getFrontCustomName: function(params) {
    return request({
      url: '/GetFrontCustomName',
      method: 'post',
      data: {
        MessageType: 4010,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn
        }
      }
    })
  },
  getFrontCustomProvince: function(params) {
    return request({
      url: '/GetFrontCustomProvince',
      method: 'post',
      data: {
        MessageType: 4011,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn
        }
      }
    })
  },
  getFrontCustomExporter: function(params) {
    return request({
      url: '/GetFrontCustomExporter',
      method: 'post',
      data: {
        MessageType: 4012,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin
        }
      }
    })
  },
  getFrontCustomCuts: function(params) {
    return request({
      url: '/GetFrontCustomCuts',
      method: 'post',
      data: {
        MessageType: 4013,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn,
          Origin: params.Origin,
          MeatType: params.MeatType
        }
      }
    })
  },
  getFrontCustomMultiData: function(params) {
    return request({
      url: '/GetFrontCustomMultiData',
      method: 'post',
      data: {
        MessageType: 4014,
        MessageID: btcguid(),
        Data: {
          ReqType: params.ReqType,
          Origin: params.Origin,
          Custom: params.Custom,
          Province: params.Province,
          MeatType: params.MeatType,
          StorageMode: params.StorageMode,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  getFrontCustomSingleData: function(params) {
    return request({
      url: '/GetFrontCustomSingleData',
      method: 'post',
      data: {
        MessageType: 4015,
        MessageID: btcguid(),
        Data: {
          Cuts: params.Cuts,
          Origin: params.Origin,
          PlantNo: params.PlantNo,
          MeatType: params.MeatType,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  getFrontCustomReportByImporter: function(params) {
    return request({
      url: '/GetFrontCustomReportByImporter',
      method: 'post',
      data: {
        MessageType: 4016,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn,
          Origin: params.Origin,
          Custom: params.Custom,
          Cuts: params.Cuts,
          MeatType: params.MeatType,
          Year: params.Year,
          Month: params.Month,
          StartDate: params.StartDate,
          EndDate: params.EndDate,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  getFrontCustomReportByCuts: function(params) {
    return request({
      url: '/GetFrontCustomReportByCuts',
      method: 'post',
      data: {
        MessageType: 4017,
        MessageID: btcguid(),
        Data: {
          Section: params.Section,
          isEn: params.isEn,
          Origin: params.Origin,
          PlantNo: params.PlantNo,
          Year: params.Year,
          Month: params.Month,
          StartDate: params.StartDate,
          EndDate: params.EndDate,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  getFrontCustomReportByPlant: function(params) {
    return request({
      url: '/GetFrontCustomReportByPlant',
      method: 'post',
      data: {
        MessageType: 4018,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin,
          Cuts: params.Cuts,
          Year: params.Year,
          Month: params.Month,
          StartDate: params.StartDate,
          EndDate: params.EndDate,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  getFrontApprovePlantOrigin: function(params) {
    return request({
      url: '/GetFrontApprovePlantOrigin',
      method: 'post',
      data: {
        MessageType: 4019,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn
        }
      }
    })
  },
  getFrontApprovePlantProvince: function(params) {
    return request({
      url: '/GetFrontApprovePlantProvince',
      method: 'post',
      data: {
        MessageType: 4020,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn,
          Origin: params.Origin,
          PlantNo: params.PlantNo
        }
      }
    })
  },
  getFrontApprovePlant: function(params) {
    return request({
      url: '/GetFrontApprovePlant',
      method: 'post',
      data: {
        MessageType: 4021,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin,
          PlantNo: params.PlantNo,
          Location: params.Location,
          MeatType: params.MeatType,
          StorageMode: params.StorageMode,
          IsDesc: params.IsDesc,
          UserID: params.UserID,
          IsFirst: params.IsFirst,
          LanguageCode: params.LanguageCode,
          PageNum: params.PageNum,
          PageSize: params.PageSize
        }
      }
    })
  },
  getFrontGreyChannelOrigin: function(params) {
    return request({
      url: '/GetFrontGreyChannelOrigin',
      method: 'post',
      data: {
        MessageType: 4022,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn,
          OriginType: params.OriginType
        }
      }
    })
  },
  getFrontExportToChinatTableData: function(params) {
    return request({
      url: '/GetFrontExportToChinatTableData',
      method: 'post',
      data: {
        MessageType: 4023,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin,
          MeatType: params.MeatType,
          StorageMode: params.StorageMode,
          StartDate: params.StartDate,
          EndDate: params.EndDate,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  getFrontPorkDataOrigin: function(params) {
    return request({
      url: '/GetFrontPorkDataOrigin',
      method: 'post',
      data: {
        MessageType: 4024,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn,
          ReqType: params.ReqType
        }
      }
    })
  },
  getFrontPorkData: function(params) {
    return request({
      url: '/GetFrontPorkData',
      method: 'post',
      data: {
        MessageType: 4025,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin,
          ReqType: params.ReqType,
          MeatType: params.MeatType,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  getFrontPorkDataTable: function(params) {
    return request({
      url: '/GetFrontPorkDataTable',
      method: 'post',
      data: {
        MessageType: 4026,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin,
          ReqType: params.ReqType,
          MeatType: params.MeatType,
          StorageMode: params.StorageMode,
          StartDate: params.StartDate,
          EndDate: params.EndDate,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  getFrontPorkDataCustomItems: function(params) {
    return request({
      url: '/GetFrontPorkDataCustomItems',
      method: 'post',
      data: {
        MessageType: 4027,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn,
          ReqType: params.ReqType,
          Custom: params.MeatType
        }
      }
    })
  },
  getFrontPorkDataCustomTrend: function(params) {
    return request({
      url: '/GetFrontPorkDataCustomTrend',
      method: 'post',
      data: {
        MessageType: 4028,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin,
          Custom: params.Custom,
          Province: params.Province,
          MeatType: params.MeatType,
          ReqType: params.ReqType,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  getFrontPorkDataCustomList: function(params) {
    return request({
      url: '/GetFrontPorkDataCustomList',
      method: 'post',
      data: {
        MessageType: 4029,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin,
          Custom: params.Custom,
          ReqType: params.ReqType,
          MeatType: params.MeatType,
          StartDate: params.StartDate,
          EndDate: params.EndDate,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  getFrontPorkDataEstItems: function(params) {
    return request({
      url: '/GetFrontPorkDataEstItems',
      method: 'post',
      data: {
        MessageType: 4030,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn,
          Origin: params.Origin,
          ReqType: params.ReqType
        }
      }
    })
  },
  getFrontPorkDataEst: function(params) {
    return request({
      url: '/GetFrontPorkDataEst',
      method: 'post',
      data: {
        MessageType: 4031,
        MessageID: btcguid(),
        Data: {
          IsDesc: params.IsDesc,
          Origin: params.Origin,
          Location: params.Location,
          MeatType: params.MeatType,
          StorageMode: params.StorageMode,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst
        }
      }
    })
  },
  addPlantSearchInfo: function(params) {
    return request({
      url: '/AddPlantSearchInfo',
      method: 'post',
      data: {
        MessageType: 4032,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          SearchContent: params.SearchContent,
          SearchSection: params.SearchSection,
          SearchCategory: params.SearchCategory
        }
      }
    })
  },
  getFrontApprovePlantNo: function(params) {
    return request({
      url: '/GetFrontApprovePlantNo',
      method: 'post',
      data: {
        MessageType: 4033,
        MessageID: btcguid(),
        Data: {
          isEn: params.isEn,
          Origin: params.Origin,
          Location: params.Location
        }
      }
    })
  },
  getFrontApprovePlantPattern: function(params) {
    return request({
      url: '/GetFrontApprovePlantPattern',
      method: 'post',
      data: {
        MessageType: 4034,
        MessageID: btcguid(),
        Data: {
          Keyword: params.KeyWords,
          LanguageCode: params.LanguageCode,
          UserID: params.UserID,
          IsFirst: params.IsFirst,
          Type: params.Type
        }
      }
    })
  },
  getFrontApprovePlantPermission: function(params) {
    return request({
      url: '/GetFrontApprovePlantPermission',
      method: 'post',
      data: {
        MessageType: 4035,
        MessageID: btcguid(),
        Data: {
          Type: params.Type,
          IsEn: params.IsEn,
          IsRead: params.IsRead,
          Origin: params.Origin,
          UserID: params.UserID
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/data.js